import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import CodeCategorySelector from './CodeCategorySelector';
import BundleFilterSelector from './BundleFilterSelector';
import CodeLocationSelector from './CodeLocationSelector';
import TextSearchCodeMappings from './TextSearchCodeMappings';
import TextSearchCodes from './TextSearchCodes';
import TextSearchDescpriptions from './TextSearchDescriptions';
import UsageDetailSelector from './UsageDetailSelector';
import MappingStateFilters from './MappingStateFilters/MappingStateFilters';

const searchClass = `w-100 rounded px-2`;

const FiltersRow = () => {
    const displayUsageDetails = useSelector(
        (state) => state.daylight.userHasAccessToCodeUsageDetails,
        shallowEqual
    );

    const practiceIsFinalized = useSelector(
        (state) => state.daylight.practiceIsFinalized
    );

    return (
        <tr
            className="bg-dark text-light sticky-top border-bottom" 
            style={{ top: '2.37rem' }}>
            {/* empty cell for checkbox column */}
            {!practiceIsFinalized && <th style={{ width: '36px', minWidth: '36px' }}></th>}
            {/* epmty row for the row number column*/}
            <th scope="col" className="col col-small"></th>

            {/* category column category selector */}
            <CodeCategorySelector />

            {/* Is Code Bundle column filter */}
            <BundleFilterSelector />

            {/* Text search against the "Code" column */}
            <TextSearchCodes searchClass={searchClass} />

            {/* Description column filter text input */}
            <TextSearchDescpriptions searchClass={searchClass} />

            {/* legacy sales price empty filter column */}
            <th className="col col-small">&nbsp;</th>

            {/* Location column filter selector */}
            <CodeLocationSelector />

            {/* Usage details column filter selector */}
            {displayUsageDetails && <UsageDetailSelector />}

            {/* TTM - empty filter column */}
            <th className="col col-small">&nbsp;</th>

            {/* Mappings column text search input */}
            <TextSearchCodeMappings searchClass={searchClass} />

            {/* empty column to put the action buttons */}
            <th className="col col-actions" >
                <MappingStateFilters />
            </th>
        </tr>
    );
};

export default FiltersRow;
